module.exports = __webpack_public_path__ + "static/media/logoheader.218bac6e.png";